<div [class]="groupClasses">
  <ng-content></ng-content>
</div>
